import FormExtend from "pages/CompensationExtend/components/FormExtend/FormExtend";

export default FormExtend